import { ImageViewerImageSource } from '@psl/components/media/types';
import { memo, useCallback, useMemo, useState } from 'react';
import ImagesViewer from 'react-images-viewer';

export const ImageViewer = memo(
  (props: {
    images: ImageViewerImageSource[];
    index?: number;
    show: boolean;
    shareButton?: boolean;
    onDismiss: () => void;
  }) => {
    const data = useMemo(
      () =>
        props.images.map(img =>
          typeof img === 'string'
            ? { src: img }
            : {
                src: img.url,
                srcset: img.srcset,
                caption: img.caption,
                thumbnail: img.thumbnail,
                className: img.className,
                thumbnailClassName: img.thumbnailClassName,
              },
        ),
      [props.images],
    );

    const [currImg, setCurrImg] = useState(props.index ?? 0);

    const onClickPrev = useCallback(() => {
      setCurrImg(currImg - 1);
    }, [currImg]);

    const onClickNext = useCallback(() => {
      setCurrImg(currImg + 1);
    }, [currImg]);

    const onClickThumbnail = useCallback((index: number) => {
      setCurrImg(index);
    }, []);

    return (
      <ImagesViewer
        imgs={data}
        currImg={currImg}
        isOpen={props.show}
        backdropCloseable={true}
        showThumbnails={true}
        onClickPrev={onClickPrev}
        onClickNext={onClickNext}
        onClickThumbnail={onClickThumbnail}
        onClose={props.onDismiss}
      />
    );
  },
);
